import { PdpProductSizeType } from '../graphql/pdp-integrated-data_types.2';

export enum SizeRecommendObjectId {
  SIMILAR_SIZE = 'similar_size',
  OTHER_SIZE = 'other_size',
  INPUT_BODY_INFO = 'input_body_info',
}

export const getSizeRecommendObjectId = (recommendationType: PdpProductSizeType) => {
  switch (recommendationType) {
    case PdpProductSizeType.PURCHASE:
    case PdpProductSizeType.RECOMMENDATION:
      return SizeRecommendObjectId.SIMILAR_SIZE;
    case PdpProductSizeType.OPTION:
      return SizeRecommendObjectId.OTHER_SIZE;
    case PdpProductSizeType.NONE:
    default:
      return SizeRecommendObjectId.INPUT_BODY_INFO;
  }
};
